import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_92: FaireProductEntity = {
  token: "starter_collection_92",
  type: "product",
  name: "The Air Whisk",
  brandName: "Material",
  imageUrl:
    "https://cdn.faire.com/fastly/3276ecc7ea1bef4a6fc59b07e7671540baa7306c7b81453b3d92619ee46c6205.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 28,
  msrpDollars: 56,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
